import { isPlatformServer } from "@angular/common";
import { inject, InjectionToken, PLATFORM_ID } from "@angular/core";

export const IS_SERVER_TOKEN = new InjectionToken<boolean>('IS_SERVER_TOKEN', {
  providedIn: 'root',
  factory: () => {
    return isPlatformServer(inject(PLATFORM_ID));
  }
});
